/**
 * Trunnion AI - Route Path Constants
 */

export const ROUTES = {
  LOGIN: '/login',
  DASHBOARD: '/dashboard',

  WORKFLOWS: '/workflows',
  WORKFLOW_NEW: '/workflows/new',
  WORKFLOW_EDIT: (id: string) => `/workflows/${id}/edit`,
  WORKFLOW_DETAIL: (id: string) => `/workflows/${id}`,

  EXECUTIONS: '/executions',
  EXECUTION_DETAIL: (id: string) => `/executions/${id}`,
  EXECUTION_COMPARE: '/executions/compare',

  AGENTS: '/agents',
  AGENT_DETAIL: (id: string) => `/agents/${id}`,
  AGENT_NEW: '/agents/new',
  AGENT_CHAT: (id: string) => `/agents/${id}/chat`,

  AUDIT: '/audit',

  ADMIN: '/admin',
  ADMIN_POLICIES: '/admin/policies',
  ADMIN_TOOLS: '/admin/tools',
  ADMIN_LLM: '/admin/llm',
  ADMIN_USERS: '/admin/users',
  ADMIN_SIMULATOR: '/admin/simulator',

  TEMPLATES: '/templates',
  SETTINGS: '/settings',
  SEARCH: '/search',
  MISSIONS: '/missions',
} as const;
